export function removeBodyPrefixClasses(prefix: string): void {
  if (typeof document !== 'undefined' && document.body) {
    const classesToRemove: string[] = []
    for (let i = 0; i < document.body.classList.length; i++) {
      const className = document.body.classList.item(i)
      if (className && className.startsWith(prefix)) {
        classesToRemove.push(className)
      }
    }
    classesToRemove.forEach((className) => {
      document.body.classList.remove(className)
    })
  }
}
